var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"truncate align-bottom"},[_c('div',{staticClass:"text-center",class:{ hidden: _vm.icon }},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"text-center",attrs:{"title":_vm.title}},[(_vm.icon)?_c('icon',{staticClass:"m-auto",attrs:{"name":_vm.icon,"width":_vm.iconSize,"height":_vm.iconSize}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }